/**
 * Held items: tools-sports
 */
import * as THREE from 'three';

export function buildHeld_guitar(lib, itemGroup) {
  // ĐÀN GUITAR ACOUSTIC GỖ CHUẨN VOXEL SẮC SẢO
  const woodMat = new THREE.MeshStandardMaterial({ color: '#b45309', roughness: 0.6 }); // Gỗ cánh gián
  const darkWoodMat = new THREE.MeshStandardMaterial({ color: '#451a03', roughness: 0.8 });
  const holeMat = new THREE.MeshBasicMaterial({ color: '#09090b' });
  const wireMat = new THREE.MeshStandardMaterial({ color: '#f8fafc', metalness: 0.8, roughness: 0.2 });
  lib.disposables.push(woodMat, darkWoodMat, holeMat, wireMat);

  // Thùng đàn dáng số 8 (2 khối hộp bo tỷ lệ)
  const bodyLowGeo = new THREE.BoxGeometry(0.3, 0.32, 0.09);
  const bodyLow = new THREE.Mesh(bodyLowGeo, woodMat);
  bodyLow.position.set(0, -0.2, 0);
  itemGroup.add(bodyLow);

  const bodyUpGeo = new THREE.BoxGeometry(0.24, 0.24, 0.085);
  const bodyUp = new THREE.Mesh(bodyUpGeo, woodMat);
  bodyUp.position.set(0, 0.06, 0);
  itemGroup.add(bodyUp);

  // Lỗ thoát âm tròn đen ở giữa thùng đàn
  const holeGeo = new THREE.BoxGeometry(0.08, 0.08, 0.095);
  const hole = new THREE.Mesh(holeGeo, holeMat);
  hole.position.set(0, 0.05, 0);
  itemGroup.add(hole);

  // Ngựa đàn phía dưới
  const bridgeGeo = new THREE.BoxGeometry(0.12, 0.025, 0.095);
  const bridge = new THREE.Mesh(bridgeGeo, darkWoodMat);
  bridge.position.set(0, -0.22, 0);
  itemGroup.add(bridge);

  // Cần đàn dài có phím bấm
  const neckGeo = new THREE.BoxGeometry(0.06, 0.52, 0.04);
  const neck = new THREE.Mesh(neckGeo, darkWoodMat);
  neck.position.set(0, 0.4, 0);
  itemGroup.add(neck);

  // Đầu cần đàn và 6 núm lên dây đàn
  const headGeo = new THREE.BoxGeometry(0.08, 0.14, 0.05);
  const head = new THREE.Mesh(headGeo, woodMat);
  head.position.set(0, 0.7, 0);
  itemGroup.add(head);

  // Dây đàn kim loại sáng
  const stringGeo = new THREE.BoxGeometry(0.035, 0.78, 0.05);
  const strings = new THREE.Mesh(stringGeo, wireMat);
  strings.position.set(0, 0.16, 0.03);
  itemGroup.add(strings);

  // Góc xoay chuẩn để cây đàn ôm chéo trước ngực nhân vật góc 35°
  itemGroup.rotation.set(0.35, -0.25, -0.75);
  lib.disposables.push(bodyLowGeo, bodyUpGeo, holeGeo, bridgeGeo, neckGeo, headGeo, stringGeo);
}

export function buildHeld_dumbbell(lib, itemGroup) {
  // TẠ TAY THỂ HÌNH GYMER NẶNG CHUẨN VOXEL (Bánh tạ to lực lưỡng, thanh inox dài)
  const ironMat = new THREE.MeshStandardMaterial({ color: '#27272a', metalness: 0.85, roughness: 0.3 });
  const barMat = new THREE.MeshStandardMaterial({ color: '#94a3b8', metalness: 0.9, roughness: 0.2 });
  lib.disposables.push(ironMat, barMat);

  // Thanh cầm inox dài lộ rõ hai bên nắm tay
  const barGeo = new THREE.CylinderGeometry(0.022, 0.022, 0.52, 10);
  const bar = new THREE.Mesh(barGeo, barMat);
  itemGroup.add(bar);

  // Hai cụm bánh tạ tròn tách xa nắm tay (2 bánh lớn + 1 bánh nhỏ + khóa chặn mỗi đầu)
  const plateLargeGeo = new THREE.CylinderGeometry(0.1, 0.1, 0.04, 16);
  const plateSmallGeo = new THREE.CylinderGeometry(0.075, 0.075, 0.035, 16);
  const collarGeo = new THREE.CylinderGeometry(0.035, 0.035, 0.03, 10);
  [-1, 1].forEach((side) => {
    [0.17, 0.215].forEach((off) => {
      const plate = new THREE.Mesh(plateLargeGeo, ironMat);
      plate.position.y = side * off;
      itemGroup.add(plate);
    });
    const plateSmall = new THREE.Mesh(plateSmallGeo, ironMat);
    plateSmall.position.y = side * 0.252;
    itemGroup.add(plateSmall);
    const collar = new THREE.Mesh(collarGeo, barMat);
    collar.position.y = side * 0.135;
    itemGroup.add(collar);
  });
  lib.disposables.push(plateLargeGeo, plateSmallGeo, collarGeo);

  itemGroup.rotation.z = Math.PI / 2; // Cầm ngang tay
  lib.disposables.push(barGeo);
}

export function buildHeld_keyboard(lib, itemGroup) {
  // BÀN PHÍM CƠ TKL CHUẨN VOXEL (CÁC KEYCAP NỔI KHỐI 3D RÕ RỆT)
  const caseMat = new THREE.MeshStandardMaterial({ color: '#1e293b', roughness: 0.5 }); // Case xám đen
  const alphaMat = new THREE.MeshStandardMaterial({ color: '#f8fafc', roughness: 0.35 }); // Phím Alpha trắng ngà
  const modMat = new THREE.MeshStandardMaterial({ color: '#475569', roughness: 0.4 }); // Phím Modifiers xám
  const accentMat = new THREE.MeshStandardMaterial({ color: '#06b6d4', roughness: 0.3 }); // Spacebar & Enter Cyan
  const escMat = new THREE.MeshStandardMaterial({ color: '#ef4444', roughness: 0.3 }); // Phím ESC đỏ cam
  const ledMat = new THREE.MeshBasicMaterial({ color: '#38bdf8' }); // Dải LED gầm RGB neon
  lib.disposables.push(caseMat, alphaMat, modMat, accentMat, escMat, ledMat);

  // Case bàn phím vát cạnh công thái học
  const caseGeo = new THREE.BoxGeometry(0.42, 0.18, 0.04);
  const kbCase = new THREE.Mesh(caseGeo, caseMat);
  itemGroup.add(kbCase);

  // Dải LED RGB rực rỡ xung quanh viền dưới
  const ledGeo = new THREE.BoxGeometry(0.43, 0.015, 0.038);
  const ledBar = new THREE.Mesh(ledGeo, ledMat);
  ledBar.position.y = -0.088;
  itemGroup.add(ledBar);

  // 1. Hàng Function Keys (F1 - F12) trên cùng
  // Phím ESC đỏ
  const escGeo = new THREE.BoxGeometry(0.028, 0.022, 0.02);
  const escKey = new THREE.Mesh(escGeo, escMat);
  escKey.position.set(-0.165, 0.065, 0.025);
  itemGroup.add(escKey);

  // Các cụm F1-F4, F5-F8, F9-F12
  for (let i = 0; i < 9; i++) {
    const fGeo = new THREE.BoxGeometry(0.024, 0.02, 0.018);
    const fKey = new THREE.Mesh(fGeo, modMat);
    const fX = -0.12 + i * 0.033 + (i >= 4 ? 0.012 : 0);
    fKey.position.set(fX, 0.065, 0.025);
    itemGroup.add(fKey);
    lib.disposables.push(fGeo);
  }

  // 2. Hàng số (Number Row 1 - 0)
  for (let i = 0; i < 11; i++) {
    const numGeo = new THREE.BoxGeometry(0.026, 0.022, 0.022);
    const numKey = new THREE.Mesh(numGeo, alphaMat);
    numKey.position.set(-0.165 + i * 0.03, 0.032, 0.026);
    itemGroup.add(numKey);
    lib.disposables.push(numGeo);
  }

  // Phím Backspace
  const bsGeo = new THREE.BoxGeometry(0.045, 0.022, 0.022);
  const bsKey = new THREE.Mesh(bsGeo, modMat);
  bsKey.position.set(0.175, 0.032, 0.026);
  itemGroup.add(bsKey);

  // 3. Hàng chữ QWERTY và ASDFGH (Alphas)
  [-0.002, -0.035].forEach((rowY, rIdx) => {
    for (let c = 0; c < 10; c++) {
      const keyGeo = new THREE.BoxGeometry(0.026, 0.022, 0.024);
      const key = new THREE.Mesh(keyGeo, alphaMat);
      key.position.set(-0.145 + c * 0.031 + rIdx * 0.01, rowY, 0.026);
      itemGroup.add(key);
      lib.disposables.push(keyGeo);
    }
  });

  // Phím Enter to nổi bật
  const enterGeo = new THREE.BoxGeometry(0.052, 0.025, 0.025);
  const enterKey = new THREE.Mesh(enterGeo, accentMat);
  enterKey.position.set(0.168, -0.035, 0.026);
  itemGroup.add(enterKey);

  // 4. Phím cách Spacebar dài nổi bật ở hàng dưới cùng
  const spaceGeo = new THREE.BoxGeometry(0.18, 0.024, 0.025);
  const spaceKey = new THREE.Mesh(spaceGeo, accentMat);
  spaceKey.position.set(-0.02, -0.068, 0.026);
  itemGroup.add(spaceKey);

  // Cụm 4 phím mũi tên điều hướng (Arrow Cluster)
  const arrowCoords = [
    { x: 0.165, y: -0.052 }, // Up
    { x: 0.138, y: -0.072 }, // Left
    { x: 0.165, y: -0.072 }, // Down
    { x: 0.192, y: -0.072 } // Right
  ];
  arrowCoords.forEach((c) => {
    const arGeo = new THREE.BoxGeometry(0.022, 0.018, 0.022);
    const arKey = new THREE.Mesh(arGeo, modMat);
    arKey.position.set(c.x, c.y, 0.026);
    itemGroup.add(arKey);
    lib.disposables.push(arGeo);
  });

  itemGroup.rotation.set(0.45, 0.2, 0.4);
  lib.disposables.push(caseGeo, ledGeo, escGeo, bsGeo, enterGeo, spaceGeo);
}

export const tools_sports_held_builders = {
  guitar: buildHeld_guitar,
  dumbbell: buildHeld_dumbbell,
  keyboard: buildHeld_keyboard
};
